class Pointer {
    constructor(value) {
        let pointerValue = null;

        return new class Pointer {
            constructor() { pointerValue = value; }

            valueOf() { return pointerValue; }
            set(v) { return pointerValue = v; }

            get value() { return this.valueOf(); }
            set value(value) { this.set(value); }
        }
    }
}

export default Pointer;
export { Pointer };

